// stores/cartStore.js
// Cart Store - Synchronized with Mobile App (adapted for web with localStorage)
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],
      totalItems: 0,
      totalPrice: 0,

      // Sync cart from API response
      syncCart: (cartData) => {
        const items = cartData?.items || [];
        // Count distinct items (not total quantity)
        const totalItems = items.length;
        const totalPrice =
          cartData?.total ||
          cartData?.totalPrice ||
          items.reduce((sum, item) => {
            const price =
              item.product?.price ||
              item.product?.variants?.[0]?.price ||
              item.price ||
              0;
            return sum + price * item.quantity;
          }, 0);

        set({ items, totalItems, totalPrice: Math.round(totalPrice * 100) / 100 });
      },

      // Local cart operations (for optimistic updates)
      addItem: (product, quantity = 1) =>
        set((state) => {
          const existingItem = state.items.find(
            (item) => item.id === product.id
          );
          let newItems;

          if (existingItem) {
            newItems = state.items.map((item) =>
              item.id === product.id
                ? { ...item, quantity: item.quantity + quantity }
                : item
            );
          } else {
            newItems = [...state.items, { ...product, quantity }];
          }

          return {
            items: newItems,
            totalItems: newItems.length, // Count distinct items
            totalPrice: newItems.reduce(
              (sum, item) => sum + (item.price || 0) * item.quantity,
              0
            ),
          };
        }),

      removeItem: (productId) =>
        set((state) => {
          const newItems = state.items.filter((item) => item.id !== productId);
          return {
            items: newItems,
            totalItems: newItems.length, // Count distinct items
            totalPrice: newItems.reduce(
              (sum, item) => sum + (item.price || 0) * item.quantity,
              0
            ),
          };
        }),

      updateQuantity: (productId, quantity) =>
        set((state) => {
          const newItems = state.items.map((item) =>
            item.id === productId ? { ...item, quantity } : item
          );
          return {
            items: newItems,
            totalItems: newItems.length, // Count distinct items
            totalPrice: newItems.reduce(
              (sum, item) => sum + (item.price || 0) * item.quantity,
              0
            ),
          };
        }),

      clearCart: () =>
        set({
          items: [],
          totalItems: 0,
          totalPrice: 0,
        }),
    }),
    {
      name: "cart-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

